import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup } from "@angular/forms";
import { EcommService } from "src/app/services/ecomm.service";
import { constApi } from "src/environments/constApi";
import { environment } from "src/environments/environment";
declare var jQuery: any;
declare var swal: any;
declare var $: any;

@Component({
  selector: "app-footer-two",
  templateUrl: "./footer-two.component.html",
  styleUrls: ["./footer-two.component.sass"],
})
export class FooterTwoComponent implements OnInit {
  alertas(titulo, msg, tipo, btn) {
    (function ($) {
      swal(titulo, msg, {
        icon: tipo,
        buttons: {
          confirm: {
            className: btn,
          },
        },
      });
    })(jQuery);
  }
  fbSubscribir: FormGroup;
  valuesEcom: any[] = [];
  constructor(private ecommService: EcommService, private fb: FormBuilder) {}

  ngOnInit() {
    this.getValEcom();
    this.buildForm();
  }
  buildForm() {
    this.fbSubscribir = this.fb.group({
      email: [""],
    });
  }

  getValEcom() {
    let param = [{ clave: "Tipo", valor: "VALECOM" }];
    this.ecommService
      .getParam(environment.apiUrlAdm,constApi.ENUMTIPO, param)
      .subscribe((res: any) => {
        this.valuesEcom = res.filter((x) => x.ValorI != 1);
        this.valuesEcom.sort(function (a, b) {
          if (a.ValorI > b.ValorI) {
            return 1;
          }
          if (a.ValorI < b.ValorI) {
            return -1;
          }
          // a must be equal to b
          return 0;
        });
      });
  }

  subscribirCliente() {
    //console.log(this.fbSubscribir.get("email").value);
    //console.log("click aqui");
    let param = {
      idSuscrito: 0,
      eMail: this.fbSubscribir.get("email").value,
    };

    this.ecommService
      .createSinTk(environment.apiUrlAdm,constApi.SUSCRITOS, param)
      .subscribe((res: any) => {
        //console.log(res);
        this.fbSubscribir.get("email").setValue("");
        // alert("Gracias por suscribirse");
        this.alertas(
          "Gracias por suscribirte",
          "Estaras recibiendo nuestras principales ofertas",
          "info",
          "info"
        );
      });
  }
}
